/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-anonymous-default-export */
import * as d3 from 'd3'
import wordwrap from 'wordwrapjs'
import toIcon from './assets/end2.png'
import airIcon from './assets/airports.png'
import educationalIcon from './assets/educational.png'
import railwayIcon from './assets/railway.png'
import marketIcon from './assets/market.png'
import hospitalIcon from './assets/hospital.png'
import busIcon from './assets/bus.png'
import fromIcon from './assets/star2.png'
import mapImg from './assets/map-2a.png'
import lineList from './lines'
import stationList from './stations'
import airportsList from './airports'
import educationalInstitutesList from './EducationalInstitutes'
import railwayList from './Railway'
import marketList from './Market'
import hospitalList from './Hospital'
import busList from './Bus'
import { station, transfer } from './curve'

export default function () {
  let margin = { top: 0, right: 0, bottom: 0, left: 0 }
  let width = 760
  let height = 640
  const xScale: any = d3.scaleLinear()
  const yScale: any = d3.scaleLinear()
  let lineWidth: any;
  const lineWidthMultiplier = 1
  let svg
  let _data: any;
  let gMap: any;

  const listeners = d3.dispatch('click')

  function map(selection: any) {
    selection.each(function (data: any) {
      _data = transformData(data)

      const minX: any =
        // @ts-ignore
        d3.min(_data.raw, function (line: any) {
          return d3.min(line.nodes, function (node: any) {
            return node.coords[0]
          })
        }) - 1


      const maxX: any =
        // @ts-ignore
        d3.max(_data.raw, function (line: any) {
          return d3.max(line.nodes, function (node: any) {
            return node.coords[0]
          })
        }) + 1

      const minY: any =
        // @ts-ignore
        d3.min(_data.raw, function (line: any) {
          return d3.min(line.nodes, function (node: any) {
            return node.coords[1]
          })
        }) - 1

      const maxY: any =
        // @ts-ignore
        d3.max(_data.raw, function (line: any) {
          return d3.max(line.nodes, function (node: any) {
            return node.coords[1]
          })
        }) + 1

      const desiredAspectRatio = (maxX - minX) / (maxY - minY)
      const actualAspectRatio =
        (width - margin.left - margin.right) /
        (height - margin.top - margin.bottom)

      const ratioRatio = actualAspectRatio / desiredAspectRatio
      let maxXRange
      let maxYRange

      // Note that we flip the sense of the y-axis here
      if (desiredAspectRatio > actualAspectRatio) {
        maxXRange = width - margin.left - margin.right
        maxYRange = (height - margin.top - margin.bottom) * ratioRatio
      } else {
        maxXRange = (width - margin.left - margin.right) / ratioRatio
        maxYRange = height - margin.top - margin.bottom
      }

      xScale.domain([minX, maxX]).range([margin.left, margin.left + maxXRange])
      yScale.domain([minY, maxY]).range([margin.top + maxYRange, margin.top])
	  
	  
	  // const screenWidth = window.innerWidth;
	  // let svgWidthPercentage;

	  // if (screenWidth >= 1024) {
	  //   // Large screens (e.g., `lg` in Tailwind)
	  //   svgWidthPercentage = '100%';
	  // } else if (screenWidth >= 768) {
	  //   // Medium screens (e.g., `md` in Tailwind)
	  //   svgWidthPercentage = '100%';
	  // } else {
	  //   // Small screens (e.g., `sm` in Tailwind)
	  //   svgWidthPercentage = '100%';
	  // }

      // lineWidth = lineWidthMultiplier * unitLength;
      lineWidth = 5
      svg = selection
        .append('svg')
        .style('width', '100%')
        // .style('width', svgWidthPercentage)
        .style('height', '100%')
        .style('border-radius', '20px')

      gMap = svg.append('g')

      gMap.on('drag', () => {
        // @ts-ignore
        const label = d3.select(this)
        const name = label.attr('id')
        // @ts-ignore
        d3.dispatch('drag').call('drag', this, name)
      })

      gMap.append('g')
        .append('foreignObject')
        .attr('height', 945)
        .attr('width', 1020)
        .append('xhtml:div')
        .style('height', '100%')
        .style('width', '100%')
        .append('img')
        .attr('id', 'tube-map')
        .style('height', '100%')
        .style('width', '100%')
        .attr('src', mapImg)
        .style('pointer-events', 'auto')
        // .style('opacity', 0.5)
        .on('click', function () {
          // Handle click event here
          // @ts-ignore
          d3.selectAll('.airport-name')
            .style('visibility', 'hidden')
          d3.selectAll('.educational-name')
            .style('visibility', 'hidden')
          d3.selectAll('.railway-name')
            .style('visibility', 'hidden')
          d3.selectAll('.bus-name')
            .style('visibility', 'hidden')
          d3.selectAll('.market-name')
            .style('visibility', 'hidden')

          d3.selectAll('#places')
            .style('visibility', 'hidden')
          d3.selectAll('#educational')
            .style('visibility', 'hidden')
          d3.selectAll('#railway')
            .style('visibility', 'hidden')
          d3.selectAll('#bus')
            .style('visibility', 'hidden')
          d3.selectAll('#market')
            .style('visibility', 'hidden')
        });

      // drawRiver()
      drawLines();
      (data?.locality) && drawLocalityLines(data);
      (data?.locality) && drawLocalityFlags(data);
      (data?.locality) && localityDrawLabels(data);
      drawInterchanges()
      drawTransferStations()
      drawStations()
      drawFlags()
      drawLabels()
      drawAirport()
      drawEducationalInstitute()
      drawRailway()
      drawMarket()
      drawHospital()
      drawBusStand()
    })
  }

  map.width = function (w: any) {
    if (!arguments?.length) return width
    width = w
    return map
  }

  map.height = function (h: any) {
    if (!arguments?.length) return height
    height = h
    return map
  }

  map.margin = function (m: any) {
    if (!arguments?.length) return margin
    margin = m
    return map
  }

  map.on = function () {
    // @ts-ignore
    const value = listeners.on.apply(listeners, arguments)
    return value === listeners ? map : value
  }

  // function drawRiver() {
  //   const riverBase = gMap
  //     .append('g')
  //     .attr('class', 'river')
  //     .attr('style', `transform: scale(0.3) translate(230px);`)
  //   riverBase
  //     .append('path')
  //     .attr(
  //       'd',
  //       `M 1776 43 q 750 723 1334 1462 a 481.9 481.9 90 0 1 46 257 C 3168 1927 3202 2063 3271 2208 Q 3354 2326 3464 2422 L 3747 2691 Q 3816 2767 4607 3541`
  //     )
  //     .attr('stroke', '#c1e8f7')
  //     .attr('fill', 'none')
  //     .attr('stroke-width', '60px')
  //   riverBase
  //     .append('text')
  //     .attr('transform', `translate(2020.05 293.28) rotate(45)`)
  //     .text('Yamuna')
  // }

  function drawLines() {
    gMap
      .append('g')
      .attr('class', 'lines')
      .selectAll('path')
      .data(_data.lines.lines.filter((d: any) => !d.nodes[0].coords[2]))
      .enter()
      .append('line')
      .attr('x1', (d: any) => xScale(d.nodes[0].coords[0]))
      .attr('x2', (d: any) => xScale(d.nodes[1].coords[0]))

      .attr('y1', (d: any) => yScale(d.nodes[0].coords[1]))
      .attr('y2', (d: any) => yScale(d.nodes[1].coords[1]))
      .attr('id', function (d: any) {
        return d.name
      })
      .attr('stroke', function (d: any) {
        return d.color
      })
      .attr('fill', 'none')
      .attr('stroke-width', function (d: any) {

        return d.highlighted ? lineWidth * 1.3 : lineWidth
      })
      .classed('line', true)
  }


  function drawLocalityLines(data: any) {
    if (data?.locality?.from) {
      gMap
        .append('g')
        .attr('class', 'localitylines')
        .append('line')
        .attr('x1', xScale(data?.locality?.from?.fromSt?.x))
        .attr('x2', xScale(data?.locality?.from?.toSt?.x))

        .attr('y1', yScale(data?.locality?.from?.fromSt?.y))
        .attr('y2', yScale(data?.locality?.from?.toSt?.y))
        .attr('id', "fromlocality")
        .attr('stroke', "#0000ff5c")
        .attr('fill', 'none')
        .attr('stroke-width', 7)
        .classed('line', true)
    }

    if (data?.locality?.to) {
      gMap
        .append('g')
        .attr('class', 'localitylines')
        .append('line')
        .attr('x1', xScale(data?.locality?.to?.fromSt?.x))
        .attr('x2', xScale(data?.locality?.to?.toSt?.x))

        .attr('y1', yScale(data?.locality?.to?.fromSt?.y))
        .attr('y2', yScale(data?.locality?.to?.toSt?.y))
        .attr('id', "tolocality")
        .attr('stroke', "#0000ff5c")
        .attr('fill', 'none')
        .attr('stroke-width', 7)
        .classed('line', true)
    }
  }

  function drawTransferStations() {
    const bgColor = '#ffffff'
    gMap
      .append('g')
      .attr('class', 'transferStations')
      .selectAll('path')
      .data(_data.stations.transferStations().filter((d: any) => !d.coords.hidden))
      .enter()
      .append('g')
      .attr('id', function (d: any) {
        return d.name
      })
      .on('click', function () {
        // @ts-ignore
        const label = d3.select(this)
        const name = label.attr('id')
        // @ts-ignore
        listeners.call('click', this, name)
      })
      .append('path')
      .attr('d', transfer(lineWidth))
      .attr('transform', (d: any) => `translate(${xScale(d.x)},${yScale(d.y)})`)
      .attr('stroke-width', lineWidth / 2.5)
      .attr('fill', (d: any) => bgColor)
      // .attr('fill', (d: any) => d.marker[0].color)
      .attr('stroke', (d: any) => d.marker[0].color)
      .classed('transferStation', true)
      .style('cursor', 'pointer')
  }

  function drawLocalityFlags(data: any) {
    if (data?.locality?.from) {
      gMap
        .append('g')
        .attr('class', 'localityfromFlags')
        .append('foreignObject')
        .attr('height', 30)
        .attr('width', 20)
        .attr('x', xScale(data?.locality?.from?.fromSt?.x) - 10)
        .attr('y', yScale(data?.locality?.from?.fromSt?.y) - 30)
        .append('xhtml:div')
        .attr('id', "fromltfromFlag")
        .append('img')
        .attr('height', 20)
        .attr('width', 20)
        .attr('src', fromIcon)
    }

    if (data?.locality?.to) {
      gMap
        .append('g')
        .attr('class', 'localitytoFlags')
        .append('foreignObject')
        .attr('height', 30)
        .attr('width', 20)
        .attr('x', xScale(data?.locality?.to?.toSt?.x) - 10)
        .attr('y', yScale(data?.locality?.to?.toSt?.y) - 30)
        .append('xhtml:div')
        .attr('id', "tolttoFlag")
        .append('img')
        .attr('height', 20)
        .attr('width', 20)
        .attr('src', toIcon)
    }
  }

  function drawFlags() {
    gMap
      .append('g')
      .attr('class', 'fromFlags')
      .selectAll('foreignObject')
      .data(
        _data.stations
          .interchanges()
          .concat(
            _data.stations.transferStations(),
            _data.stations.normalStations()
          )
      )
      .enter()
      .append('foreignObject')
      .attr('height', 30)
      .attr('width', 20)
      .attr('x', (d: any) => {
        return xScale(d.x) - 10
      })
      .attr('y', (d: any) => {
        return yScale(d.y) - 30
      })
      .append('xhtml:div')
      .attr('id', (d: any) => d.name + 'fromFlag')
      .append('img')
      .attr('height', 20)
      .attr('width', 20)
      .attr('src', fromIcon)

    gMap
      .append('g')
      .attr('class', 'toFlags')
      .selectAll('foreignObject')
      .data(
        _data.stations
          .interchanges()
          .concat(
            _data.stations.transferStations(),
            _data.stations.normalStations()
          )
      )
      .enter()
      .append('foreignObject')
      .attr('height', 30)
      .attr('width', 20)
      .attr('x', (d: any) => {
        return xScale(d.x) - 10
      })
      .attr('y', (d: any) => {
        return yScale(d.y) - 30
      })
      .append('xhtml:div')
      .attr('id', (d: any) => d.name + 'toFlag')
      .append('img')
      .attr('height', 20)
      .attr('width', 20)
      .attr('src', toIcon)
  }

  function drawInterchanges() {
    const bgColor = '#ffffff'

    gMap
      .append('g')
      .attr('class', 'interchanges')
      .selectAll('rect')
      .data(_data.stations.interchanges())
      .enter()
      .append('g')
      .attr('id', function (d: { name: any }) {
        return d.name
      })
      .on('click', function () {
        // @ts-ignore
        const label = d3.select(this)
        const name = label.attr('id')
        // @ts-ignore
        listeners.call('click', this, name)
      })
      .append('rect')
      .attr('x', (d: any) => xScale(d.x) - 4)
      .attr('y', (d: any) => yScale(d.y) - 8)
      .attr('width', 8)
      .attr('height', 16)
      .attr('rx', 4)
      .attr('stroke-width', lineWidth / 3)
      .attr('fill', (d: any) => bgColor)
      .attr('stroke', (d: any) => d.marker[0].color)
      .classed('interchange', true)
      .style('cursor', 'pointer')
  }

  function drawStations() {
    const bgColor = '#ffffff'
    gMap
      .append('g')
      .attr('class', 'stations')
      .selectAll('path')
      .data(_data.stations.normalStations())
      .enter()
      .append('g')
      .attr('id', function (d: any) {
        return d.name
      })
      .on('click', function () {
        // @ts-ignore
        const label = d3.select(this)
        const name = label.attr('id')
        // @ts-ignore
        listeners.call('click', this, name)
      })
      .append('path')
      .attr('d', station(lineWidth))
      .attr('transform', (d: any) => `translate(${xScale(d.x)},${yScale(d.y)})`)
      .attr('stroke-width', lineWidth / 2.5)
      .attr('fill', (d: any) => bgColor)
      // .attr('stroke', (d: any) => d.marker[0].color)
      .attr('stroke', "#1AD5FF")
      .attr('display', (d: any) => !!d.name ? "block" : "none")
      .classed('station', true)
      .style('cursor', 'pointer')
  }

  function drawAirport() {
    gMap
      .append('g')
      .attr('class', 'places')
      .attr('id', 'places')
      .selectAll('foreignObject')
      .data(_data.airports.airports)
      .enter()
      .append('foreignObject')
      .attr('height', 50)
      .attr('width', 400)
      .attr('x', (d: any) => {
        return xScale(d.x) - 15
      })
      .attr('y', (d: any) => {
        return yScale(d.y) - 45
      })
      .append('xhtml:div')
      .attr('class', 'airport-container') // Add a class for styling
      .append('img')
      .attr('id', 'places-icon')
      .attr('height', 60)
      .attr('width', 40)
      .attr('src', airIcon)
      .attr('data-name', (d: { name: string }) => d.name)
      .on('click', function () {
        // @ts-ignore
        const container = d3.select(this.parentNode); // Get the parent node
        const targetName = container.select('.airport-name'); // Select the airport-name div inside the parent node
        const visibility = targetName.style('visibility'); // Get the current visibility
        targetName.style('visibility', visibility === 'hidden' ? 'visible' : 'hidden'); // Toggle visibility
        // Hide other markers
        d3.selectAll('.hospital-name')
          .style('visibility', 'hidden')
        d3.selectAll('.railway-name')
          .style('visibility', 'hidden')
        d3.selectAll('.educational-name')
          .style('visibility', 'hidden')
        d3.selectAll('.bus-name')
          .style('visibility', 'hidden')
        d3.selectAll('.market-name')
          .style('visibility', 'hidden')
      })

    // Append a div to display the name
    d3.selectAll('.airport-container')
      .append('div')
      .attr('class', 'airport-name') // Add a class for styling
      .attr('id', 'airport-name') // Add an id
      .text(function (d: any) { return (d as { label: string }).label; })
      .style('margin-top', '-40px')
      .style('margin-left', '40px')
      .style('font-size', '12px')
      .style('width', 'fit-content')
      .style('padding', '10px')
      .style('background', 'linear-gradient(80deg, rgb(97, 9, 90) -0.21%, rgb(138, 6, 128) 86.05%)')
      .style('color', '#fff')
      .style('font-weight', '500')
      .style('border-radius', '10px')
      .style('visibility', 'hidden')
  }

  function drawEducationalInstitute() {
    gMap
      .append('g')
      .attr('class', 'educational')
      .attr('id', 'educational')
      .selectAll('foreignObject')
      .data(_data.educational_institutes.educational_institutes)
      .enter()
      .append('foreignObject')
      .attr('height', 50)
      .attr('width', 400)
      .attr('x', (d: any) => {
        return xScale(d.x) - 15
      })
      .attr('y', (d: any) => {
        return yScale(d.y) - 45
      })
      .append('xhtml:div')
      .attr('class', 'educational-container') // Add a class for styling
      .append('img')
      .attr('id', 'educational-icon')
      .attr('height', 60)
      .attr('width', 40)
      .attr('src', railwayIcon)
      .attr('data-name', (d: { name: string }) => d.name)
      .on('click', function () {
        // @ts-ignore
        const container = d3.select(this.parentNode); // Get the parent node
        const targetName = container.select('.educational-name'); // Select the educational-name div inside the parent node
        const visibility = targetName.style('visibility'); // Get the current visibility
        targetName.style('visibility', visibility === 'hidden' ? 'visible' : 'hidden'); // Toggle visibility

        // Hide other markers
        d3.selectAll('.hospital-name')
          .style('visibility', 'hidden')
        d3.selectAll('.railway-name')
          .style('visibility', 'hidden')
        d3.selectAll('.airport-name')
          .style('visibility', 'hidden')
        d3.selectAll('.bus-name')
          .style('visibility', 'hidden')
        d3.selectAll('.market-name')
          .style('visibility', 'hidden')
      })

    // Append a div to display the name
    d3.selectAll('.educational-container')
      .append('div')
      .attr('class', 'educational-name') // Add a class for styling
      .attr('id', 'educational-name') // Add an id
      .text(function (d: any) { return (d as { label: string }).label; })
      .style('margin-top', '-40px')
      .style('margin-left', '40px')
      .style('font-size', '12px')
      .style('width', 'fit-content')
      .style('padding', '10px')
      .style('background', 'linear-gradient(80deg, rgb(97, 9, 90) -0.21%, rgb(138, 6, 128) 86.05%)')
      .style('color', '#fff')
      .style('font-weight', '500')
      .style('border-radius', '10px')
      .style('visibility', 'hidden')
  }

  function drawRailway() {
    gMap
      .append('g')
      .attr('class', 'railway')
      .attr('id', 'railway')
      .selectAll('foreignObject')
      .data(_data.railway.railway)
      .enter()
      .append('foreignObject')
      .attr('height', 50)
      .attr('width', 400)
      .attr('x', (d: any) => {
        return xScale(d.x) - 15
      })
      .attr('y', (d: any) => {
        return yScale(d.y) - 45
      })
      .append('xhtml:div')
      .attr('class', 'railway-container') // Add a class for styling
      .append('img')
      .attr('id', 'railway-icon')
      .attr('height', 60)
      .attr('width', 40)
      .attr('src', railwayIcon)
      .attr('data-name', (d: { name: string }) => d.name)
      .on('click', function () {
        // @ts-ignore
        const container = d3.select(this.parentNode); // Get the parent node
        const targetName = container.select('.railway-name'); // Select the railway-name div inside the parent node
        const visibility = targetName.style('visibility'); // Get the current visibility
        targetName.style('visibility', visibility === 'hidden' ? 'visible' : 'hidden'); // Toggle visibility

        // Hide other markers
        d3.selectAll('.hospital-name')
          .style('visibility', 'hidden')
        d3.selectAll('.airport-name')
          .style('visibility', 'hidden')
        d3.selectAll('.educational-name')
          .style('visibility', 'hidden')
        d3.selectAll('.bus-name')
          .style('visibility', 'hidden')
        d3.selectAll('.market-name')
          .style('visibility', 'hidden')
      })

    // Append a div to display the name
    d3.selectAll('.railway-container')
      .append('div')
      .attr('class', 'railway-name') // Add a class for styling
      .attr('id', 'railway-name') // Add an id
      .text(function (d: any) { return (d as { label: string }).label; })
      .style('margin-top', '-40px')
      .style('margin-left', '40px')
      .style('font-size', '12px')
      .style('width', 'fit-content')
      .style('padding', '10px')
      .style('background', 'linear-gradient(80deg, rgb(97, 9, 90) -0.21%, rgb(138, 6, 128) 86.05%)')
      .style('color', '#fff')
      .style('font-weight', '500')
      .style('border-radius', '10px')
      .style('visibility', 'hidden')
  }

  function drawMarket() {
    gMap
      .append('g')
      .attr('class', 'market')
      .attr('id', 'market')
      .selectAll('foreignObject')
      .data(_data.market.market)
      .enter()
      .append('foreignObject')
      .attr('height', 50)
      .attr('width', 400)
      .attr('x', (d: any) => {
        return xScale(d.x) - 15
      })
      .attr('y', (d: any) => {
        return yScale(d.y) - 45
      })
      .append('xhtml:div')
      .attr('class', 'market-container') // Add a class for styling
      .append('img')
      .attr('id', 'market-icon')
      .attr('height', 60)
      .attr('width', 40)
      .attr('src', marketIcon)
      .attr('data-name', (d: { name: string }) => d.name)
      .on('click', function () {
        // @ts-ignore
        const container = d3.select(this.parentNode); // Get the parent node
        const targetName = container.select('.market-name'); // Select the market-name div inside the parent node
        const visibility = targetName.style('visibility'); // Get the current visibility
        targetName.style('visibility', visibility === 'hidden' ? 'visible' : 'hidden'); // Toggle visibility

        // Hide other markers
        d3.selectAll('.hospital-name')
          .style('visibility', 'hidden')
        d3.selectAll('.airport-name')
          .style('visibility', 'hidden')
        d3.selectAll('.educational-name')
          .style('visibility', 'hidden')
        d3.selectAll('.bus-name')
          .style('visibility', 'hidden')
        d3.selectAll('.railway-name')
          .style('visibility', 'hidden')
      })

    // Append a div to display the name
    d3.selectAll('.market-container')
      .append('div')
      .attr('class', 'market-name') // Add a class for styling
      .attr('id', 'market-name') // Add an id
      .text(function (d: any) { return (d as { label: string }).label; })
      .style('margin-top', '-40px')
      .style('margin-left', '40px')
      .style('font-size', '12px')
      .style('width', 'fit-content')
      .style('padding', '10px')
      .style('background', 'linear-gradient(80deg, rgb(97, 9, 90) -0.21%, rgb(138, 6, 128) 86.05%)')
      .style('color', '#fff')
      .style('font-weight', '500')
      .style('border-radius', '10px')
      .style('visibility', 'hidden')
  }

  function drawHospital() {
    gMap
      .append('g')
      .attr('class', 'hospital')
      .attr('id', 'hospital')
      .selectAll('foreignObject')
      .data(_data.hospital.hospital)
      .enter()
      .append('foreignObject')
      .attr('height', 50)
      .attr('width', 400)
      .attr('x', (d: any) => {
        return xScale(d.x) - 15
      })
      .attr('y', (d: any) => {
        return yScale(d.y) - 45
      })
      .append('xhtml:div')
      .attr('class', 'hospital-container') // Add a class for styling
      .append('img')
      .attr('id', 'hospital-icon')
      .attr('height', 60)
      .attr('width', 40)
      .attr('src', hospitalIcon)
      .attr('data-name', (d: { name: string }) => d.name)
      .on('click', function () {
        // @ts-ignore
        const container = d3.select(this.parentNode); // Get the parent node
        const targetName = container.select('.hospital-name'); // Select the hospital-name div inside the parent node
        const visibility = targetName.style('visibility'); // Get the current visibility
        targetName.style('visibility', visibility === 'hidden' ? 'visible' : 'hidden'); // Toggle visibility

        // Hide other markers
        d3.selectAll('.market-name')
          .style('visibility', 'hidden')
        d3.selectAll('.airport-name')
          .style('visibility', 'hidden')
        d3.selectAll('.educational-name')
          .style('visibility', 'hidden')
        d3.selectAll('.bus-name')
          .style('visibility', 'hidden')
        d3.selectAll('.railway-name')
          .style('visibility', 'hidden')
      })

    // Append a div to display the name
    d3.selectAll('.hospital-container')
      .append('div')
      .attr('class', 'hospital-name') // Add a class for styling
      .attr('id', 'hospital-name') // Add an id
      .text(function (d: any) { return (d as { label: string }).label; })
      .style('margin-top', '-40px')
      .style('margin-left', '40px')
      .style('font-size', '12px')
      .style('width', 'fit-content')
      .style('padding', '10px')
      .style('background', 'linear-gradient(80deg, rgb(97, 9, 90) -0.21%, rgb(138, 6, 128) 86.05%)')
      .style('color', '#fff')
      .style('font-weight', '500')
      .style('border-radius', '10px')
      .style('visibility', 'hidden')
  }

  function drawBusStand() {
    gMap
      .append('g')
      .attr('class', 'bus')
      .attr('id', 'bus')
      .selectAll('foreignObject')
      .data(_data.bus.bus)
      .enter()
      .append('foreignObject')
      .attr('height', 50)
      .attr('width', 400)
      .attr('x', (d: any) => {
        return xScale(d.x) - 15
      })
      .attr('y', (d: any) => {
        return yScale(d.y) - 45
      })
      .append('xhtml:div')
      .attr('class', 'bus-container') // Add a class for styling
      .append('img')
      .attr('id', 'bus-icon')
      .attr('height', 60)
      .attr('width', 40)
      .attr('src', busIcon)
      .attr('data-name', (d: { name: string }) => d.name)
      .on('click', function () {
        // @ts-ignore
        const container = d3.select(this.parentNode); // Get the parent node
        const targetName = container.select('.bus-name'); // Select the bus-name div inside the parent node
        const visibility = targetName.style('visibility'); // Get the current visibility
        targetName.style('visibility', visibility === 'hidden' ? 'visible' : 'hidden'); // Toggle visibility
      })

    // Append a div to display the name
    d3.selectAll('.bus-container')
      .append('div')
      .attr('class', 'bus-name') // Add a class for styling
      .attr('id', 'bus-name') // Add an id
      .text(function (d: any) { return (d as { label: string }).label; })
      .style('margin-top', '-40px')
      .style('margin-left', '40px')
      .style('font-size', '12px')
      .style('width', 'fit-content')
      .style('padding', '10px')
      .style('background', 'linear-gradient(80deg, rgb(97, 9, 90) -0.21%, rgb(138, 6, 128) 86.05%)')
      .style('color', '#fff')
      .style('font-weight', '500')
      .style('border-radius', '10px')
      .style('visibility', 'hidden')
  }

  function localityDrawLabels(data: any) {
    if (data?.locality?.from) {
      gMap
        .append('g')
        .attr('class', 'fromlabels')
        .append('g')
        .attr('id', "fromlocality")
        .classed('label', true)
        .append('text')
        .text(data?.locality?.from?.fromSt?.name)
        .attr('fill', '#000')
        .attr('dy', 0)
        .attr('x', xScale(data?.locality?.from?.fromSt?.x) - 50)
        .attr('y', yScale(data?.locality?.from?.fromSt?.y) + 15)
        .style('font-size', 1.8 * lineWidth + 'px')
        .style('font-family', 'Urbanist')
        .style('font-weight', '700')
        .style('-webkit-user-select', 'none')
    }

    if (data?.locality?.to) {
      gMap
        .append('g')
        .attr('class', 'tolabels')
        .append('g')
        .attr('id', "tolocality")
        .classed('label', true)
        .append('text')
        .text(data?.locality?.to?.toSt?.name)
        .attr('fill', '#000')
        .attr('dy', 0)
        .attr('x', xScale(data?.locality?.to?.toSt?.x) - 50)
        .attr('y', yScale(data?.locality?.to?.toSt?.y) + 15)
        .style('font-size', 1.8 * lineWidth + 'px')
        .style('font-family', 'Urbanist')
        .style('font-weight', '700')
        .style('-webkit-user-select', 'none')
    }
  }

  function drawLabels() {
    gMap
      .append('g')
      .attr('class', 'labels')
      .selectAll('text')
      .data(_data.stations.toArray())
      .enter()
      .append('g')
      .attr('id', function (d: any) {
        return d.name
      })
      .classed('label', true)
      .on('click', function () {
        // @ts-ignore
        const label = d3.select(this)
        const name = label.attr('id')
        // @ts-ignore
        listeners.call('click', this, name)
      })
      .append('text')
      .text(function (d: any) {
        return d.label
      })
      .attr('fill', '#000')
      .attr('dy', 0)
      .attr('x', function (d: any) {
        const shiftX = d.labelShiftX
        // @ts-ignore
        return xScale(d.x + shiftX * lineWidthMultiplier) + textPos(d).pos[0]
      })
      .attr('y', function (d: any) {
        const shiftY = d.labelShiftY
        // @ts-ignore
        return yScale(d.y + shiftY * lineWidthMultiplier) - textPos(d).pos[1]
      })
      .attr('text-anchor', function (d: any) {
        return textPos(d).textAnchor
      })
      .style('display', function (d: any) {
        return d.hide !== true ? 'block' : 'none'
      })
      .style('text-decoration', function (d: any) {
        return d.closed ? 'line-through' : 'none'
      })
      .style('font-size', 1.8 * lineWidth + 'px')
      .style('font-family', 'Urbanist')
      .style('font-weight', '700')
      .style('-webkit-user-select', 'none')
      .attr('class', function (d: any) {
        return d.marker
          .map(function (marker: any) {
            return marker.line
          })
          .join(' ')
      })
      .classed('highlighted', function (d: any) {
        return d.visited
      })
      .call(wrap, function (d: any) {
        return textPos(d).alignmentBaseline
      })
  }

  function transformData(data: any) {
    return {
      raw: data.lines,
      stations: extractStations(data),
      lines: extractLines(data.lines),
      airports: extractAirports(data.airports),
      educational_institutes: extractEducationalInstitutes(data.educational_institutes),
      railway: extractRailway(data.railway),
      market: extractMarket(data.market),
      hospital: extractHospital(data.hospital),
      bus: extractBus(data.bus)
    }
  }

  function extractStations(data: any) {
    data.lines.forEach(function (line: any) {
      for (let node = 0; node < line.nodes.length; node++) {
        const d = line.nodes[node]

        if (!d.hasOwnProperty('name')) continue

        if (!data.stations.hasOwnProperty(d.name))
          throw new Error('Cannot find station with key: ' + d.name)

        const station = data.stations[d.name]

        station.x = d.coords[0]
        station.y = d.coords[1]

        if (station.labelPos === undefined || d.hasOwnProperty('canonical')) {
          station.labelPos = d.labelPos
          station.labelShiftX = d.hasOwnProperty('labelShiftCoords')
            ? d.labelShiftCoords[0]
            : d.hasOwnProperty('shiftCoords')
              ? d.shiftCoords[0]
              : line.shiftCoords[0]
          station.labelShiftY = d.hasOwnProperty('labelShiftCoords')
            ? d.labelShiftCoords[1]
            : d.hasOwnProperty('shiftCoords')
              ? d.shiftCoords[1]
              : line.shiftCoords[1]
          station.labelShiftNormal = line.hasOwnProperty('shiftNormal')
            ? line.shiftNormal
            : 0
          station.dir = d.dir
        }

        station.label = data.stations[d.name].label
        station.position = data.stations[d.name].position
        station.closed = data.stations[d.name].hasOwnProperty('closed')
          ? data.stations[d.name].closed
          : false
        station.visited = false

        if (!d.hide) {
          station.marker = station.marker || []

          station.marker.push({
            line: line.name,
            color: line.color,
            labelPos: d.labelPos,
            dir: d.dir,
            marker: d.hasOwnProperty('marker') ? d.marker : 'station',
            shiftX: d.hasOwnProperty('shiftCoords')
              ? d.shiftCoords[0]
              : line.shiftCoords[0],
            shiftY: d.hasOwnProperty('shiftCoords')
              ? d.shiftCoords[1]
              : line.shiftCoords[1],
            shiftNormal: line.hasOwnProperty('shiftNormal')
              ? line.shiftNormal
              : 0,
          })
        }
      }
    })

    return stationList(data.stations)
  }

  function extractLines(data: any) {
    const lines: any = []

    data.forEach(function (line: any) {
      const lineObj: any = {
        name: line.name,
        title: line.label,
        stations: [],
        color: line.color,
        shiftCoords: line.shiftCoords,
        shiftNormal: line.shiftNormal,
        nodes: line.nodes,
        highlighted: false,
      }

      lines.push(lineObj)

      for (let node = 0; node < line.nodes.length; node++) {
        const data: any = line.nodes[node]

        if (!data.hasOwnProperty('name')) continue

        lineObj.stations.push(data.name)
      }
    })

    return lineList(lines)
  }

  function extractAirports(data: any) {
    return airportsList(data)
  }

  function extractEducationalInstitutes(data: any) {
    return educationalInstitutesList(data)
  }

  function extractRailway(data: any) {
    return railwayList(data)
  }

  function extractMarket(data: any) {
    return marketList(data)
  }

  function extractHospital(data: any) {
    return hospitalList(data)
  }

  function extractBus(data: any) {
    return busList(data)
  }

  function textPos(data: any) {
    let pos
    let textAnchor
    let alignmentBaseline
    const offset = lineWidth * 1.8

    const numLines = data.label.split(/\n/).length

    const sqrt2 = Math.sqrt(2)

    switch (data.labelPos.toLowerCase()) {
      case 'n':
        pos = [0, 2.1 * lineWidth * (numLines - 1) + offset]
        textAnchor = 'middle'
        alignmentBaseline = 'baseline'
        break
      case 'ne':
        pos = [offset / sqrt2, (lineWidth * (numLines - 1) + offset) / sqrt2]
        textAnchor = 'start'
        alignmentBaseline = 'baseline'
        break
      case 'e':
        pos = [offset, 0]
        textAnchor = 'start'
        alignmentBaseline = 'middle'
        break
      case 'se':
        pos = [offset / sqrt2, -offset / sqrt2]
        textAnchor = 'start'
        alignmentBaseline = 'hanging'
        break
      case 's':
        pos = [0, -lineWidthMultiplier * offset]
        textAnchor = 'middle'
        alignmentBaseline = 'hanging'
        break
      case 'sw':
        pos = [-offset / sqrt2, -offset / sqrt2]
        textAnchor = 'end'
        alignmentBaseline = 'hanging'
        break
      case 'w':
        pos = [-offset, 0]
        textAnchor = 'end'
        alignmentBaseline = 'middle'
        break
      case 'nw':
        pos = [
          -(lineWidth * (numLines - 1) + offset) / sqrt2,
          (lineWidth * (numLines - 1) + offset) / sqrt2,
        ]
        textAnchor = 'end'
        alignmentBaseline = 'baseline'
        break
      default:
        break
    }

    return {
      pos: pos,
      textAnchor: textAnchor,
      alignmentBaseline: alignmentBaseline,
    }
  }

  function fixY(lines: any, d: any, y: any) {
    return ['middle', 'baseline'].includes(textPos(d).alignmentBaseline as any) &&
      lines?.length > 1
      ? y - 5
      : y
  }

  // Render line breaks for svg text
  function wrap(text: any, baseline: any) {
    text.each(function () {
      // @ts-ignore
      const text = d3.select(this)
      const lines = wordwrap.lines(text.text(), {
        width: 20,
      })
      const y = text.attr('y')
      const x = text.attr('x')
      const dy = parseFloat(text.attr('dy'))

      text
        .text(null)
        .append('tspan')
        .style('font-size', 2 * lineWidth + 'px')
        .style('text-transform', 'capitalize')
        .style('color', 'white')
        .attr('x', x)
        .attr('y', function (d: any) {
          return fixY(lines, d, y)
        })
        .attr('dy', dy + 'em')
        .attr('dominant-baseline', baseline)
        .text(lines?.toString()?.replace(",", " "))

      // for (let lineNum = 1; lineNum < lines?.length; lineNum++) {
      //   text
      //     .append('tspan')
      //     .style('font-size', 2 * lineWidth + 'px')
      //     .style('text-transform', 'capitalize')
      //     .style('text-align', 'center')
      //     .attr('x', x)
      //     .attr('y', function (d: any) {
      //       return fixY(lines, d, y)
      //     })
      //     .attr('dy', lineNum * 1.1 + dy + 'em')
      //     .attr('dominant-baseline', baseline)
      //     .text(lines[lineNum])
      // }
    })
  }

  return map
}